//Routes

export const SEARCH_ROUTE = '/search';
export const ACCIDENT_ROUTE = '/accident';
export const HOME_ROUTE = '/home';
export const TRACKING_ROUTE = '/tracking';
export const THIRD_PARTY_CLAIM_ROUTE = '/reclamo-terceros';
export const THIRD_PARTY_CLAIM_SUMMARY_ROUTE = '/reclamo-terceros/resumen';
export const CLAIM_STATUS_ROUTE = '/seguimiento';
